module.exports = __webpack_public_path__ + "static/resume-0a9a12c45829773e1d0e0f408e320994.pdf";